const menuTypes = {
    primary: 'primary',
    secondary: 'secondary',
    tertiary: 'tertiary',
    none: 'none'
};

export default menuTypes;
